import React from 'react'

import isDOMAvailable from 'utils/isDOMAvailable'

import Backdrop from 'components/atoms/Backdrop'
import NotificationContent from 'components/notifications/molecules/NotificationContent'

const NotificationPopover = ({ close }) => (
    <>
      <div className="notification-popover">
        <div className="notification-popover__wrapper">
          <NotificationContent />
        </div>
      </div>
      {isDOMAvailable && window.outerWidth >= 768 && document  && (
        <Backdrop
          parent={document.body}
          zIndex={98}
          onClick={close}
        />
      )}
      <style jsx global>
        {`
          .notification-popover {
            position: absolute;
            overflow: hidden;
            border-radius: 10px;
            box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);
            width: 400px;
            z-index: 99;
            top: 74px;
            right: -16px;
            background-color: #fff;

            &__wrapper {
              width: 400px;
              overflow: hidden auto;
              max-height: 560px;
              &::-webkit-scrollbar-thumb,
              &::-webkit-scrollbar-thumb:hover {
                border-radius: 16px;
                box-shadow: inset 0 0 16px 16px #BED2E8;
                border: solid 4px #F6F7FA;
              }
              &::-webkit-scrollbar {
                background-color: #F6F7FA;
                width: 16px;
              }
            }
          }
        `}
      </style>
    </>
  )

export default NotificationPopover
